// extracted by mini-css-extract-plugin
export default {"bodymain":"Main_bodymain__9HjpG","main":"Main_main__oEhay","leftpath":"Main_leftpath__NgvNE","centerpath":"Main_centerpath__X9QAy","rightpath":"Main_rightpath__nI9x0"};